<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <!-- <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1">單位</span>
      </h4> -->
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- name -->
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name"
                >
                  <b-form-group
                    label="狀態名稱："
                    label-for="name"
                    label-cols-md="6"
                    class="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="newStatusData.name"
                      placeholder="輸入狀態名稱"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              
             
              <!-- sort_order -->
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_sort_order"
                >
                  <b-form-group
                    label="排序："
                    label-for="sort_order"
                    label-cols-md="6"
                    class="required"
                  >
                    <b-form-input
                      id="sort_order"
                      v-model="newStatusData.sort_order"
                      type="number"
                      placeholder="輸入排序"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- is_active -->
              <b-col cols="12">
                  <b-form-group
                    label="啟用狀態："
                    label-for="product_type_status"
                    label-cols-md="6"
                  >
                  <b-form-checkbox
                      style="margin-top: 5px"
                      checked="true"
                      value="1"
                      v-model="newStatusData.is_active"
                      class="custom-control-success"
                      name="check-button"
                      switch
                      inline
                    />

                    <span style="position: relative; top: -5px">{{
                      newStatusData.is_active ? "啟用" : "禁用"
                    }}</span>
                  </b-form-group>
              </b-col>
              
            </b-row>

            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";

export default {
  data() {
    return {
      required,
      email,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    hide() {
      this.$router.replace("/settings/product-type/list");
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.newStatusData.is_active = this.newStatusData.is_active ? 1 : 0;
          store
            .dispatch("status/editStatus", this.newStatusData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });

             this.hide();
              this.$emit('refetch-data')
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    statusData: {
      status: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newStatusData = ref({
      id: 0,
      name: "",
      sort_order: 1,
      is_active: 1,
    });

    watch(
      () => props.statusData,
      (newVal) => {
        newStatusData.value = { ...newVal };
      }
    );
    const resetWorkData = () => {
      newStatusData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          name: "",
          sort_order: 1,
          is_active: 1,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetWorkData);

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newStatusData,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>
